import { useState, useEffect } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material'
import { deleteInterpretationRule } from 'utils/InterpretationPunchRule'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

interface InterpretationRuleRow {
    id: number
    name: string
}

interface DeleteInterpretationRuleProps {
    open: boolean
    setOpenDelete: (value: boolean) => void
    selectedRow: InterpretationRuleRow[]
    reloading: () => void
}

const DeleteInterpretationRule = ({ open, setOpenDelete, selectedRow, reloading }: DeleteInterpretationRuleProps) => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<InterpretationRuleRow[]>([])
    const [ids, setIds] = useState<number[]>([])

    useEffect(() => {
        setData(selectedRow)
        setIds(selectedRow.map((item) => item.id))
    }, [selectedRow])

    const DeleteInterpretationRules = () => {
        setLoading(true)
        Promise.all(ids.map((id) => deleteInterpretationRule(setLoading, id)))
            .then(() => {
                setOpenDelete(false)
                enqueueSnackbar(t('settings.interpretation_rule.dialog.alerts.delete.success'), { variant: 'success' })
                reloading()
            })
            .catch((error: unknown) => {
                console.error(error)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpenDelete(false)}
        >
            <DialogTitle>
                <Typography variant='body2'>{t('settings.interpretation_rule.dialog.titles.delete')}</Typography>
            </DialogTitle>

            <DialogContent>
                <Typography variant='body1'>
                    {t('settings.interpretation_rule.dialog.alerts.delete.message')}
                </Typography>
                <ul>
                    {data.map((interpretation_rule, index) =>
                        <li key={index}>
                            {interpretation_rule.name}
                        </li>
                    )}
                </ul>
            </DialogContent>

            <DialogActions sx={{ pb: 2, pr: 3 }}>
                <Button variant='contained' onClick={() => setOpenDelete(false)} color='primary'>
                    {t('general.buttons.cancel')}
                </Button>
                <Button variant='contained' onClick={() => DeleteInterpretationRules()} color='error' loading={loading}>
                    {t('general.buttons.delete')}
                </Button>

            </DialogActions>
        </Dialog>
    )
}

export { DeleteInterpretationRule }
